import type { FC } from 'react';
import React from 'react';

import type { BaseSvgProps } from '../../utils';

export const Invoice: FC<BaseSvgProps> = ({ 'data-testid': testId }) => (
  <svg
    width={14}
    height={12}
    viewBox="0 0 12 10"
    fill="none"
    className="shrink-0"
    data-testid={testId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.71729 0C6.92873 1.82633e-05 7.13146 0.0792079 7.28662 0.219727L7.3501 0.283203L9.33643 2.50586C9.47532 2.66128 9.55219 2.86286 9.55225 3.07129V8.91602C9.55207 9.31487 9.22845 9.63851 8.82959 9.63867H3.17041C2.77156 9.6385 2.44793 9.31486 2.44775 8.91602V0.722656C2.44793 0.323809 2.77156 0.000174337 3.17041 0H6.71729ZM3.17041 0.602539C3.10415 0.602713 3.05047 0.656395 3.05029 0.722656V8.91602L3.06006 8.96289C3.07224 8.99141 3.09502 9.01419 3.12354 9.02637L3.17041 9.03613H8.82959L8.87646 9.02637C8.90499 9.01419 8.92776 8.99141 8.93994 8.96289L8.94971 8.91602V3.58203C8.91634 3.58727 8.8818 3.59067 8.84619 3.59082L7.021 3.59863C6.5521 3.60048 6.17148 3.21891 6.17432 2.75L6.18604 0.710938L6.1958 0.603516L3.17041 0.602539ZM6.87451 0.681641C6.84441 0.649056 6.78912 0.670375 6.78857 0.714844L6.77686 2.75391C6.77605 2.88779 6.88422 2.99648 7.01807 2.99609L8.7876 2.98926H8.84424C8.88669 2.989 8.90883 2.9378 8.88037 2.90625L6.87451 0.681641Z"
      fill="currentColor"
    />
    <path
      d="M7.49207 6.6875C7.65836 6.6875 7.79285 6.82199 7.79285 6.98828C7.79285 7.15457 7.65836 7.28906 7.49207 7.28906H4.453C4.28671 7.28906 4.15222 7.15457 4.15222 6.98828C4.15222 6.82199 4.28671 6.6875 4.453 6.6875H7.49207Z"
      fill="currentColor"
    />
    <path
      d="M7.49207 4.6875C7.65836 4.6875 7.79285 4.82199 7.79285 4.98828C7.79285 5.15457 7.65836 5.28906 7.49207 5.28906H4.453C4.28671 5.28906 4.15222 5.15457 4.15222 4.98828C4.15222 4.82199 4.28671 4.6875 4.453 4.6875H7.49207Z"
      fill="currentColor"
    />
  </svg>
);
